module.exports = __webpack_public_path__ + "static/media/clickTogether.8383d3b2.mp3";